import { AxiosError } from 'axios';

import http from '@frontend/api/http';

import { RAGConfiguration } from '../types';

export class RAGService {
  static async getConfigurations(opalInstanceId: string) {
    try {
      const response = await http.get<{ configurations: RAGConfiguration[]; total_count: number }>(
        `/backend/api/v1/instances/${opalInstanceId}/rag/configurations`
      );

      return response.data.configurations;
    } catch (error) {
      if (error instanceof AxiosError && error.response?.data?.detail) {
        throw new Error(error.response?.data?.detail);
      }
      throw new Error('Something went wrong');
    }
  }

  static async toggleConfigurationActivationStatus(
    opalInstanceId: string,
    configurationId: string
  ) {
    try {
      const response = await http.put<RAGConfiguration>(
        `/backend/api/v1/instances/${opalInstanceId}/rag/configurations/${configurationId}/activation/toggle`
      );

      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        throw new Error(error.response?.data?.detail ?? 'Something went wrong');
      }
      throw error;
    }
  }

  static async deleteConfiguration(opalInstanceId: string, configurationId: string) {
    try {
      await http.delete(
        `/backend/api/v1/instances/${opalInstanceId}/rag/configurations/${configurationId}`
      );
    } catch (error) {
      if (error instanceof AxiosError) {
        throw new Error(error.response?.data?.detail ?? 'Something went wrong');
      }
      throw error;
    }
  }
}
